import i18next from 'i18next';
import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';
import { DEV_LOGS_ENABLED } from '@fintronners/react-utils/src/envConstants';
import { apexSharesShortFormat } from '@fintronners/react-utils/src/numberUtilsTSX';
import en from './en';
import pt from './pt';

const i18nextInstance = i18next.createInstance({
  compatibilityJSON: 'v3',
  fallbackLng: 'en',
  lng: FinTronConfig.language,
  debug: DEV_LOGS_ENABLED(),
  resources: {
    en: {
      translation: en,
    },
    pt: {
      translation: pt,
    },
  },
  interpolation: {
    escapeValue: false,
  },
  defaultNS: 'translation',
});

/**
 * Initialize i18next with the language set in FinTronConfig
 */
const initI18Next = () => {
  if (!i18nextInstance.isInitialized) {
    i18nextInstance.init();

    i18nextInstance?.services?.formatter?.add('apexSharesShort', (value: number) =>
      apexSharesShortFormat(value),
    );

    i18nextInstance?.services?.formatter?.add('ytm', (ytmValue: number) => {
      // Using split strategy because toFixed() and toPrecision() was rounding the value
      const [integer, decimal] = ytmValue.toString().split('.');
      return `${integer}.${decimal.slice(0, 2)}%`;
    });

    i18nextInstance?.services?.formatter?.add('uppercase', (value: string) => value.toUpperCase());
  }

  return i18nextInstance;
};

const initializedI18Next = initI18Next();

export default initializedI18Next;
